import { enqueueSnackbar } from "notistack";
import MenuOptions from "../../../../components/order/menu/MenuOptions";
import {
  activateVisaRequirementsApi,
  deactivateVisaRequirementsApi,
} from "../../../../controllers/visaController";

export default function VisaMenu({
  data,
  mobile,
  setModal,
  callback,
  loading,
  setLoading,
}) {
  const isActive = data?.isActive;

  const handleActivate = async () => {
    setLoading?.(true);
    const res = await activateVisaRequirementsApi(data?._id).finally(() => {
      setLoading(false);
    });

    if (res?.return) {
      enqueueSnackbar(res?.msg || "Visa requirements activated successfully.", {
        variant: "success",
      });
      callback?.(res?.data);
    } else {
      enqueueSnackbar(
        "Failed to activate visa requirements. Please try again.",
        { variant: "error" }
      );
    }
  };
  const handleDectivate = async () => {
    setLoading?.(true);
    const res = await deactivateVisaRequirementsApi(data?._id).finally(() => {
      setLoading(false);
    });

    if (res?.return) {
      enqueueSnackbar(
        res?.msg || "Visa requirements deactivated successfully.",
        {
          variant: "success",
        }
      );
      callback?.(res?.data);
    } else {
      enqueueSnackbar(
        res?.msg || "Failed to deactivate visa requirements. Please try again.",
        { variant: "error" }
      );
    }
  };

  const menu = [
    {
      label: "Edit Visa",
      action: () => {
        setModal((prev) => ({ ...prev, edit: true }));
      },
      visible: true,
    },
    {
      label: isActive ? "Deactivate Visa" : "Activate Visa",
      action: () => {
        isActive ? handleDectivate() : handleActivate();
      },
      visible: true,
    },
    {
      label: "Delete Visa",
      action: () => {
        setModal((prev) => ({ ...prev, delete: true }));
      },
      visible: true,
    },
  ];

  return (
    <>
      <div className="hidden"></div>
      <MenuOptions mobile={mobile} menu={menu} />
    </>
  );
}
// Stay menu
